import script from "./ConfiguratorSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguratorSummary.vue?vue&type=script&setup=true&lang=ts"

import "./ConfiguratorSummary.vue?vue&type=style&index=0&id=6bf00058&lang=css"

const __exports__ = script;

export default __exports__